import React from "react";
import styled from "styled-components";

export default function ButtonAction({
  srcBg,
  content,
  handleClick = () => {},
  className = "",
}) {
  return (
    <Div
      className={`button-action-popup-mini" ${className}`}
       onClick={handleClick}
    >
      <img src={srcBg} alt="" />
      <div className="content-btn">{content}</div>
    </Div>
  );
}

const Div = styled.div`
  position: relative;
  width: max-content;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  img {
    height: 60px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  .content-btn {
    position: absolute;
    left: 50%;
    top: calc(50% - 4px);
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    font-weight: 500;
    width: max-content;
  }

  @media (min-width: 992px) {
    &:hover {
      scale: 1.03;
      cursor: pointer;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 768px) {
    &.button-action-popup-mini__coin {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      img {
        height: 45px;
      }
    }
  }

  @media (max-width: 425px) {
    .content-btn {
      font-size: 14px;
    }

    &.button-action-popup-mini__coin {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      img {
        height: 38px;
      }
    }

    img {
      height: auto;
    }
  }
`;
